import React from 'react';
import { useTooltip, useGlobalState } from '../../hooks';
import { environments } from '../../helpers';

import './EnvironmentLabel.css';

export const EnvironmentLabel = ({ className }) => {
  const [settings] = useGlobalState('settings');
  const { showTooltip, hideTooltip } = useTooltip();

  const env = settings.ENVIRONMENT;
  return (
    <div
      className={'environment-label' + (className ? ' ' + className : '') + (env ? ' ' + env : '')}
    >
      {env && env !== 'prod' && (
        <span
          onMouseEnter={() =>
            showTooltip({
              title: `${environments.find(x => x.value === env).value.toUpperCase()} (${environments.find(x => x.value === env).label}) environment`,
            })
          }
          onMouseLeave={() => hideTooltip()}
        >
          {env}
        </span>
      )}
    </div>
  );
};
